import { Box, Chip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import zeplinColor from '../../../../theme/Color';

interface TaskHeaderProps {
  selectedData: any;
  isFromTasksPage?: boolean;
}

export const TaskHeader: React.FC<TaskHeaderProps> = ({ selectedData, isFromTasksPage }) => {
  return (
    <Box sx={{ display: 'flex', gap: { xs: '10px', xl: '16px' }, flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', gap: { xs: '4px', xl: '8px' }, flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {isFromTasksPage && (
              <Chip
                label={
                  <Typography
                    variant='responsiveLabel1'
                    color={zeplinColor.BasicBlack}
                    sx={{
                      textAlign: 'center',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {selectedData?.recordTypeName || ''}
                  </Typography>
                }
                sx={{
                  backgroundColor: zeplinColor.Neutral4,
                  borderRadius: '50px',
                  height: '22px',
                  '&.MuiChip-root': {
                    padding: '4px 8px',
                  },
                  '& .MuiChip-label': {
                    padding: 0,
                  },
                }}
              />
            )}
            {!isFromTasksPage && (
              <Chip
                label={
                  <Typography
                    variant='responsiveLabel1'
                    sx={{ display: 'flex', alignItems: 'center' }}
                    color={
                      selectedData?.source === 'SALESFORCE'
                        ? zeplinColor.Neutral1
                        : zeplinColor.BasicBlack
                    }
                  >
                    {selectedData?.source}
                  </Typography>
                }
                sx={{
                  backgroundColor:
                    selectedData?.source === 'SALESFORCE' ? zeplinColor.Blue : zeplinColor.Brand2,
                  color:
                    selectedData?.source === 'SALESFORCE'
                      ? zeplinColor.Neutral1
                      : zeplinColor.BasicBlack,
                  '&.MuiChip-root': {
                    height: '24px',
                    padding: '5px 12px',
                    borderRadius: '50px',
                  },
                  '& .MuiChip-label': {
                    padding: 0,
                  },
                }}
              />
            )}

            <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
              Created{' '}
              {selectedData?.createdDate || selectedData?.createdAt
                ? dayjs(selectedData.createdDate || selectedData.createdAt).format(
                    'D MMM, YYYY [at] h:mm A',
                  )
                : 'NA'}
            </Typography>
          </Box>
          {!isFromTasksPage && selectedData?.source === 'SALESFORCE' && (
            <a
              href={selectedData?.link}
              style={{ textDecoration: 'none' }}
              target='_blank'
              rel='noopener noreferrer'
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  width: '100%',
                  alignItems: 'center',
                  flex: 1,
                  justifyContent: 'flex-end',
                  cursor: 'pointer',
                }}
              >
                <Typography variant='responsiveButtonSmall' color={zeplinColor.Brand1}>
                  Salesforce
                </Typography>
                <img
                  width={'18px'}
                  height={'18px'}
                  src={'/assets/link-blue.svg'}
                  alt='logo'
                  style={{ objectFit: 'fill' }}
                />
              </Box>
            </a>
          )}
        </Box>
        {!isFromTasksPage && (
          <Box>
            <Chip
              label={
                <Typography
                  variant='responsiveLabel1'
                  color={zeplinColor.BasicBlack}
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {selectedData?.recordTypeName || ''}
                </Typography>
              }
              sx={{
                backgroundColor: zeplinColor.Neutral4,
                borderRadius: '50px',
                height: '22px',
                '&.MuiChip-root': {
                  padding: '4px 8px',
                },
                '& .MuiChip-label': {
                  padding: 0,
                },
              }}
            />
          </Box>
        )}
        <Typography variant='responsiveDisplay5' color={zeplinColor.BasicBlack}>
          {selectedData?.subject || 'NA'}
        </Typography>
      </Box>

      <Typography variant='body2' color={zeplinColor.BasicBlack}>
        {selectedData?.description || ''}
      </Typography>
    </Box>
  );
};
